// import React from 'react';
// import {
//   createBrowserRouter,
//   RouterProvider,
// } from "react-router-dom";
// import './App.css'
// import HomePage from './components/HomePage/HomePage';

// const App = () => {
//   const router = createBrowserRouter([
//     {
//       path: "/page",
//       element: <HomePage />,
//     },
//   ]);

//   return (
//     <div>
//       <RouterProvider router={router} />
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import HomePage from "./components/HomePage/HomePage";

const App = () => {
  // const router = createBrowserRouter([
  // {
  // path: "/",
  // element: <HomePage />,
  // },
  // ]);

  return (
    <div>
      <HomePage />
    </div>
  );
};

export default App;
